<!-- eslint-disable max-len -->
<div class="platform-form endpoint-edit-form">
  <form [formGroup]="newDSPForm">
    <div class="platform-form__top" *nzModalTitle>
      <div class="switch">
        <nz-switch
          switchLabel="activateDSPEndpoint"
          class="ssp-switch"
          [(ngModel)]="createDspService.isActiveEndpoint"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="changeEndpointActive($event)"
          name="isActiveEndpoint"
        ></nz-switch>
      </div>
      <div class="type">
        <span *ngIf="createDspService.isRtbConnection()">RTB</span>
        <span *ngIf="createDspService.isVastConnection()">VAST</span>
        <span *ngIf="createDspService.isJSConnection()">JS</span>
        <span *ngIf="createDspService.isPreBidConnection()">Prebid</span>
      </div>
      <div class="wrap">
        Demand Endpoint
        <span>Company Name</span>
      </div>
    </div>
    <div class="platform-form__middle">
      <div class="part left">
        <div class="form-title">General</div>
        <div class="form-group">
          <label for="endpointDSPName">Name *</label>
          <input
            nz-input
            type="text"
            id="endpointDSPName"
            name="name"
            required
            formControlName="name"
            (input)="keyPressAlphanumeric()"
            class="form-control"
          />
        </div>
        <div class="form-group form-group--check">
          <label class="label-title"
            >Connection Type
            <app-tooltip
              [tooltipTitle]="
                'Choose whether the endpoint works according to RTB specifications or VAST.'
              "
            ></app-tooltip>
          </label>
          <div class="form-group">
            <div class="margin-group">
              <nz-radio-group
                formControlName="connectionType"
                name="connectionType"
                id="connectionType"
                nzButtonStyle="solid"
                [attr.qa]="createDspService.formValue.connectionType"
              >
                <label nz-radio-button nzValue="rtb" style="width: 25%" qa="rtb"
                  >RTB</label
                >
                <label
                  nz-radio-button
                  nzValue="vast"
                  style="width: 25%"
                  qa="vast"
                  >VAST</label
                >
                <label
                  nz-radio-button
                  nzValue="prebid"
                  style="width: 25%"
                  [nzDisabled]="createDspService.isPartnerPlanBasic"
                  nz-tooltip
                  nzTooltipOverlayClassName="item-tooltip"
                  [nzTooltipTitle]="
                    createDspService.restrictionTooltipMessage(
                      'Prebid connection type'
                    )
                  "
                  nzTooltipPlacement="top"
                  qa="prebid"
                  >Prebid</label
                >
                <label nz-radio-button nzValue="js" style="width: 25%" qa="js"
                  >JS</label
                >
              </nz-radio-group>
            </div>
          </div>

          <div class="form-group" *ngIf="createDspService.isRtbConnection()">
            <label>OpenRTB Version</label>
            <nz-select
              nzShowSearch
              nzPlaceHolder="Select OpenRTB Version"
              formControlName="rtb_type"
              name="rtb_type"
            >
              <nz-option
                *ngFor="let version of createDspService.rtbVersions"
                [nzValue]="version.id"
                [nzLabel]="version.name"
              ></nz-option>
            </nz-select>
          </div>

          <div
            class="form-group form-group_chb"
            *ngIf="
              createDspService.isRtbConnection() ||
              createDspService.isPreBidConnection()
            "
          >
            <div class="hub-row">
              <div class="hub-part" qa="additionalSettings">
                <div class="check-tooltip">
                  <label
                    checkboxLabel="useAdapterDSP"
                    nz-checkbox
                    formControlName="useAdapter"
                    name="useAdapter"
                    (ngModelChange)="onChangeQPSAdapter($event)"
                    >QPS Adapter</label
                  >
                  <app-tooltip
                    [tooltipTitle]="
                      'Activates QPS adapter, which allocates the most relevant traffic to be sent to the DSP endpoint according to its bidding activity'
                    "
                  ></app-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-group"
            *ngIf="
              createDspService.formValue.useAdapter &&
              (createDspService.isRtbConnection() ||
                createDspService.isPreBidConnection())
            "
          >
            <label class="label-title" for="minRCPMDSP"
              >Min RCPM
              <app-tooltip
                [tooltipTitle]="
                  'The minimum required RCPM for the endpoint, the system would count it as a minimum effective for the endpoint'
                "
              ></app-tooltip>
            </label>
            <input
              nz-input
              type="number"
              class="form-control"
              id="minRCPMDSP"
              name="min_rcpm"
              B
              formControlName="min_rcpm"
            />
          </div>
          <div
            *ngIf="
              createDspService.isVastConnection() ||
              createDspService.isJSConnection()
            "
            class="form-group form-group_chb"
          >
            <div class="hub-row">
              <div class="hub-part">
                <div class="check-tooltip">
                  <label
                    checkboxLabel="useAdapterDSP"
                    nz-checkbox
                    formControlName="useAdapter"
                    name="useAdapter"
                    >QPS Adapter</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="createDspService.isRtbConnection()">
          <label>RTB Connection</label>
          <div class="btn-group btn-group--rtb">
            <label
              [class.active]="
                createDspService.formValue.rtbConnectionMode === 0
              "
            >
              RTB to ALL
              <input
                type="radio"
                formControlName="rtbConnectionMode"
                [checked]="createDspService.formValue.rtbConnectionMode === 0"
                [value]="0"
              />
            </label>
            <label
              [class.active]="
                createDspService.formValue.rtbConnectionMode === 2
              "
            >
              RTB to RTB
              <input
                type="radio"
                formControlName="rtbConnectionMode"
                [checked]="createDspService.formValue.rtbConnectionMode === 2"
                [value]="2"
              />
            </label>
            <label
              [class.active]="
                createDspService.formValue.rtbConnectionMode === 1
              "
            >
              RTB to VAST
              <input
                type="radio"
                formControlName="rtbConnectionMode"
                [checked]="createDspService.formValue.rtbConnectionMode === 1"
                [value]="1"
              />
            </label>
            <label
              [class.active]="
                createDspService.formValue.rtbConnectionMode === 3
              "
            >
              RTB to JS
              <input
                type="radio"
                formControlName="rtbConnectionMode"
                [checked]="createDspService.formValue.rtbConnectionMode === 3"
                [value]="3"
              />
            </label>
          </div>
        </div>
        <div class="form-group" *ngIf="createDspService.isVastConnection()">
          <label>VAST Connection</label>
          <div class="btn-group btn-group--vast">
            <label
              [class.active]="
                createDspService.formValue.vastConnectionMode === 0
              "
            >
              VAST to ALL
              <input
                type="radio"
                formControlName="vastConnectionMode"
                [checked]="createDspService.formValue.vastConnectionMode === 0"
                [value]="0"
              />
            </label>
            <label
              [class.active]="
                createDspService.formValue.vastConnectionMode === 2
              "
            >
              VAST to RTB
              <input
                type="radio"
                formControlName="vastConnectionMode"
                [checked]="createDspService.formValue.vastConnectionMode === 2"
                [value]="2"
              />
            </label>
            <label
              [class.active]="
                createDspService.formValue.vastConnectionMode === 1
              "
            >
              VAST to VAST
              <input
                type="radio"
                formControlName="vastConnectionMode"
                [checked]="createDspService.formValue.vastConnectionMode === 1"
                [value]="1"
              />
            </label>
          </div>
        </div>
        <div *ngIf="createDspService.isVastConnection()">
          <div class="form-title form-title--checkbox">Ad Format</div>
          <div class="form-group">
            <div class="hub-row">
              <div class="hub-part">
                <div class="checkbox">
                  <label
                    checkboxLabel="videoFormatDSPVast"
                    nz-checkbox
                    [ngClass]="
                      createDspService.isRequiredAdFormat
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="video"
                    [nzDisabled]="
                      createDspService.formValue['audio'] ||
                      createDspService.formValue['rewarded']
                    "
                    name="video"
                    >Video</label
                  >
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="rewardedVideoFormatDSPVast"
                    nz-checkbox
                    [ngClass]="
                      createDspService.isRequiredAdFormat
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="rewarded"
                    name="rewarded"
                    [nzDisabled]="
                      createDspService.formValue['video'] ||
                      createDspService.formValue['audio']
                    "
                    >Rewarded video</label
                  >
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="audioFormatDSPVast"
                    nz-checkbox
                    [ngClass]="
                      createDspService.isRequiredAdFormat
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="audio"
                    [nzDisabled]="
                      createDspService.formValue['video'] ||
                      createDspService.formValue['rewarded']
                    "
                    name="audio"
                    >Audio</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr *ngIf="createDspService.isVastConnection()" />
        <div
          class="form-group form-radio mt-20"
          *ngIf="
            createDspService.isVastConnection() ||
            createDspService.isJSConnection()
          "
        >
          <label class="form-title form-title--traffic"
            >Traffic type
            <app-tooltip
              [tooltipTitle]="
                'Choose whether the endpoint works according to RTB specifications or VAST.'
              "
            ></app-tooltip>
          </label>
          <div class="ad-types">
            <div class="radio-50">
              <label
                class="custom-radio"
                checkboxLabel="mobileWebTrafficTypeDSPVastJS"
              >
                Mobile web
                <input
                  (change)="onChangeAdType()"
                  formControlName="adtype"
                  name="adtype"
                  type="radio"
                  value="mobileWeb"
                />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="radio-50">
              <label
                class="custom-radio"
                checkboxLabel="desktopTrafficTypeDSPVastJS"
              >
                Desktop
                <input
                  (change)="onChangeAdType()"
                  type="radio"
                  formControlName="adtype"
                  name="adtype"
                  value="desktop"
                />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
          <div class="ad-types">
            <div class="radio-50">
              <label
                class="custom-radio"
                checkboxLabel="mobileAppTrafficTypeDSPVastJS"
              >
                Mobile app
                <input
                  (change)="onChangeAdType()"
                  formControlName="adtype"
                  name="adtype"
                  type="radio"
                  value="inApp"
                />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="radio-50" *ngIf="!createDspService.isJSConnection()">
              <label
                class="custom-radio"
                checkboxLabel="ctvTrafficTypeDSPVastJS"
              >
                CTV
                <input
                  (change)="onChangeAdType()"
                  formControlName="adtype"
                  name="adtype"
                  type="radio"
                  value="ctv"
                />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <hr
          *ngIf="
            createDspService.isVastConnection() ||
            createDspService.isJSConnection()
          "
        />
        <div
          *ngIf="
            createDspService.isRtbConnection() ||
            createDspService.isPreBidConnection()
          "
        >
          <div class="form-title form-title--checkbox">Ad Format</div>
          <div class="form-group">
            <div class="hub-row">
              <div class="hub-part">
                <div class="checkbox">
                  <label
                    checkboxLabel="bannerFormatDSP"
                    nz-checkbox
                    [ngClass]="
                      createDspService.isRequiredAdFormat
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="banner"
                    name="banner"
                    >Banner</label
                  >
                </div>
                <div class="checkbox-with-drop">
                  <div class="checkbox">
                    <label
                      checkboxLabel="nativeFormatDSP"
                      nz-checkbox
                      [ngClass]="
                        createDspService.isRequiredAdFormat
                          ? 'required-label'
                          : 'fake-label'
                      "
                      formControlName="native"
                      [nzDisabled]="createDspService.formValue['push']"
                      name="native"
                      >Native</label
                    >
                  </div>
                  <div
                    class="form-group"
                    *ngIf="createDspService.formValue['native']"
                  >
                    <app-select-multi-antd-control
                      [items]="createDspService.nativeVersions"
                      [selectedItems]="createDspService.nativeSpecControl.value"
                      [control]="createDspService.nativeSpecControl"
                      [placeholder]="'Choose Item'"
                      id="native"
                    >
                    </app-select-multi-antd-control>
                  </div>
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="videoFormatDSP"
                    nz-checkbox
                    [ngClass]="
                      createDspService.isRequiredAdFormat
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="video"
                    name="video"
                    >Video</label
                  >
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="rewardedVideoFormatDSP"
                    nz-checkbox
                    [ngClass]="
                      createDspService.isRequiredAdFormat
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="rewarded"
                    [nzDisabled]="createDspService.formValue['audio']"
                    name="rewarded"
                    >Rewarded video</label
                  >
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="audioFormatDSP"
                    nz-checkbox
                    [ngClass]="
                      createDspService.isRequiredAdFormat
                        ? 'required-label'
                        : 'fake-label'
                    "
                    *ngIf="createDspService.isRtbConnection()"
                    formControlName="audio"
                    [nzDisabled]="
                      createDspService.formValue['ctv'] ||
                      createDspService.formValue['rewarded']
                    "
                    name="audio"
                    >Audio</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr
          *ngIf="
            createDspService.isRtbConnection() ||
            createDspService.isPreBidConnection()
          "
        />
        <div
          class="form-title form-title--traffic"
          *ngIf="
            createDspService.isRtbConnection() ||
            createDspService.isPreBidConnection()
          "
        >
          Traffic type
        </div>
        <div
          class="form-group rtb-ad-types"
          *ngIf="
            createDspService.isRtbConnection() ||
            createDspService.isPreBidConnection()
          "
        >
          <div class="checkbox">
            <label
              checkboxLabel="mobileWebTrafficTypeDSP"
              nz-checkbox
              [ngClass]="
                createDspService.isRequiredTrafficType
                  ? 'required-label'
                  : 'fake-label'
              "
              formControlName="mobileWeb"
              name="mobileWeb"
              >Mobile web</label
            >
          </div>
          <div class="checkbox">
            <label
              checkboxLabel="mobileAppTrafficTypeDSP"
              nz-checkbox
              [ngClass]="
                createDspService.isRequiredTrafficType
                  ? 'required-label'
                  : 'fake-label'
              "
              formControlName="inApp"
              name="inApp"
              >Mobile app</label
            >
          </div>
          <div class="checkbox">
            <label
              checkboxLabel="desktopTrafficTypeDSP"
              nz-checkbox
              [ngClass]="
                createDspService.isRequiredTrafficType
                  ? 'required-label'
                  : 'fake-label'
              "
              formControlName="desktop"
              name="desktop"
              >Desktop</label
            >
          </div>
          <div class="checkbox">
            <label
              checkboxLabel="ctvTrafficTypeDSP"
              nz-checkbox
              [ngClass]="
                createDspService.isRequiredTrafficType
                  ? 'required-label'
                  : 'fake-label'
              "
              formControlName="ctv"
              [nzDisabled]="createDspService.formValue['audio']"
              name="ctv"
              >CTV</label
            >
          </div>
        </div>
        <hr
          *ngIf="
            createDspService.isRtbConnection() ||
            createDspService.isPreBidConnection()
          "
        />
        <div class="form-group">
          <label class="label-title"
            >Company *
            <app-tooltip
              [tooltipTitle]="'A company to which endpoint belongs'"
            ></app-tooltip>
          </label>
          <nz-select
            [ngClass]="
              createDspService.isRequiredCompany
                ? 'required-company'
                : 'company'
            "
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select or Create Company"
            formControlName="companyId"
            (ngModelChange)="onCompanyChange($event)"
            name="companyId"
          >
            <nz-option
              *ngFor="let company of createDspService.companies"
              [nzValue]="company.id"
              [nzLabel]="company.name"
            ></nz-option>
          </nz-select>
        </div>
        <div class="form-group">
          <label class="label-title"
            >Region *
            <app-tooltip
              [tooltipTitle]="'Region in which server capacities are located'"
            ></app-tooltip>
          </label>
          <nz-select
            [ngClass]="
              createDspService.isRequiredRegion ? 'required-region' : 'region'
            "
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select Region"
            formControlName="region"
            name="region"
          >
            <nz-option
              *ngFor="let region of createDspService.regions"
              [nzValue]="region.id"
              [nzLabel]="region.name"
            ></nz-option>
          </nz-select>
        </div>

        <div class="form-group">
          <label for="margin_type">Margin Type</label>
          <div class="margin-group">
            <nz-radio-group
              formControlName="margin_type"
              name="margin_type"
              id="margin_type"
              nzButtonStyle="solid"
              (ngModelChange)="changeMarginType($event)"
            >
              <label nz-radio-button nzValue="fixed">Fixed</label>
              <label
                nz-radio-button
                nzValue="adaptive"
                [nzDisabled]="createDspService.isPartnerPlanBasic"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createDspService.restrictionTooltipMessage(
                    'Adaptive margin type'
                  )
                "
                nzTooltipPlacement="top"
                >Adaptive</label
              >
              <label
                nz-radio-button
                nzValue="range"
                [nzDisabled]="createDspService.isPartnerPlanBasic"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createDspService.restrictionTooltipMessage(
                    'Range margin type'
                  )
                "
                nzTooltipPlacement="top"
                >Range</label
              >
            </nz-radio-group>
          </div>
          <div
            class="margin"
            *ngIf="createDspService.formValue['margin_type'] === 'fixed'"
          >
            <div class="form-group">
              <label class="label-title" for="marginDSP"
                >Margin *
                <app-tooltip
                  [tooltipTitle]="
                    'Percent that the platform charges from the endpoint revenue'
                  "
                ></app-tooltip>
              </label>
              <input
                class="form-control"
                nz-input
                type="number"
                id="marginDSP"
                name="margin"
                min="0"
                max="100"
                formControlName="margin"
                placeholder="15 %"
                required
              />
            </div>
          </div>
          <div
            class="margin-section"
            *ngIf="createDspService.formValue['margin_type'] === 'range'"
          >
            <div class="margin-section__left">
              <div class="form-group">
                <label for="minMarginDSP">Min Margin *</label>
                <input
                  class="form-control"
                  nz-input
                  type="number"
                  id="minMarginDSP"
                  name="min_margin"
                  min="1"
                  max="100"
                  formControlName="min_margin"
                  placeholder="1 %"
                  required
                />
              </div>
            </div>
            <div class="margin-section__right">
              <div class="form-group">
                <label for="maxMarginDSP">Max Margin *</label>
                <input
                  class="form-control"
                  nz-input
                  type="number"
                  id="maxMarginDSP"
                  name="max_margin"
                  min="1"
                  max="100"
                  formControlName="max_margin"
                  placeholder="100 %"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="createDspService.isVastConnection()">
          <label class="label-title" for="defaultPriceVastDSP"
            >Fixed Price *
            <app-tooltip
              tooltipTitle="The value entered here is used as the fixed payout to DSP partners. This value represents the cost per thousand impressions (CPM)"
            ></app-tooltip>
          </label>
          <input
            nz-input
            type="number"
            class="form-control"
            required
            id="defaultPriceVastDSP"
            min="0"
            name="defaultPriceVast"
            formControlName="defaultPriceVast"
          />
        </div>
        <div
          class="form-group"
          *ngIf="createDspService.isJSConnection()"
          formGroupName="js"
        >
          <label for="cpmDSP">
            Fixed CPM *
            <app-tooltip
              tooltipTitle="The value entered here is used as the fixed payout to DSP partners. This value represents the cost per thousand impressions (CPM)"
            ></app-tooltip>
          </label>
          <input
            nz-input
            type="number"
            class="form-control"
            required
            numeric
            formControlName="cpm"
            name="cpm"
            id="cpmDSP"
          />
        </div>
        <div class="form-group">
          <label class="label-title" for="spendLimitDSP"
            >Spend Limit<span *ngIf="createDspService.isJSConnection()">*</span>
            <app-tooltip
              [tooltipTitle]="'Maximum spend from this endpoint.'"
            ></app-tooltip>
          </label>
          <div class="dsp-limit">
            <input
              nz-input
              type="number"
              class="form-control"
              id="spendLimitDSP"
              name="spendLimit"
              formControlName="spendLimit"
              [required]="createDspService.isJSConnection()"
            />
          </div>
        </div>
        <div class="form-group">
          <label class="label-title" for="limitQPSDSP"
            >QPS Limit *
            <app-tooltip
              [tooltipTitle]="
                'Maximum allowed queries per second this endpoint can handle'
              "
            ></app-tooltip>
          </label>
          <div class="">
            <input
              nz-input
              type="number"
              class="form-control"
              id="limitQPSDSP"
              required
              name="limitQPS"
              formControlName="limitQPS"
            />
          </div>
        </div>
        <div
          class="form-group"
          *ngIf="
            createDspService.isRtbConnection() ||
            createDspService.isPreBidConnection()
          "
        >
          <label class="label-title"
            >Auction Type
            <app-tooltip
              [tooltipTitle]="
                'Optimized model - auction will be presented for your partners as at:2, but in fact aims to generate more earnings for you'
              "
            ></app-tooltip>
          </label>
          <nz-select
            nzShowSearch
            nzPlaceHolder="Select Auction Type"
            formControlName="auctionType"
            name="auctionType"
          >
            <nz-option
              *ngFor="let auction of createDspService.auctionTypes"
              [nzValue]="auction.id"
              [nzLabel]="auction.name"
            ></nz-option>
          </nz-select>
        </div>

        <div class="form-group">
          <div class="form-group">
            <label for="minTmaxDSP">Min tmax</label>
            <input
              nz-input
              type="number"
              class="form-control"
              id="minTmaxDSP"
              name="minTmax"
              formControlName="minTmax"
            />
          </div>
        </div>

        <div>
          <div class="row b-row">
            <div
              class="col-6"
              *ngIf="
                createDspService.isRtbConnection() ||
                createDspService.isPreBidConnection()
              "
            >
              <div class="form-group">
                <label for="min_bidfloor_replacement">
                  Min Bidfloor
                  <app-tooltip
                    tooltipTitle="Min Bidfloor Replacement
                    If the final bidfloor is below this value, it will be increased to match the configured minimum before being sent to the DSP.

                    If the final bidfloor is equal to or higher, it’s passed as is.

                    This setting does not drop requests - it ensures low bidfloors are adjusted to match the minimum value."
                  ></app-tooltip>
                </label>
                <input
                  nz-input
                  type="number"
                  min="0"
                  class="form-control"
                  id="minBidfloorReplacementDSP"
                  name="min_bidfloor_replacement"
                  formControlName="min_bidfloor_replacement"
                />
              </div>
            </div>
            <div
              [ngClass]="
                createDspService.isRtbConnection() ||
                createDspService.isPreBidConnection()
                  ? 'col-6'
                  : 'col-12'
              "
            >
              <div class="form-group">
                <label for="maxBidfloorDSP">Max Bidfloor</label>
                <input
                  nz-input
                  type="number"
                  class="form-control"
                  id="maxBidfloorDSP"
                  name="maxBidfloor"
                  formControlName="maxBidfloor"
                  qa="bidfloor"
                />
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="createDspService.isJSConnection()">
          <hr />
          <div>Size *</div>
          <div class="form-group">
            <label>Size</label>
            <nz-select
              nzShowSearch
              nzPlaceHolder="Select Size"
              formControlName="selectedSize"
              name="selectedSize"
              (ngModelChange)="onChangeSize($event)"
            >
              <nz-option
                *ngFor="let size of createDspService.listOfSizes"
                [nzValue]="size.id"
                [nzLabel]="size.name"
              ></nz-option>
            </nz-select>
          </div>
          <div class="form-group" formGroupName="js">
            <div class="row b-row dsp-api-link-wrap">
              <div class="col-6">
                <label>Width *</label>
                <input
                  id="jsWidthDSP"
                  nz-input
                  type="number"
                  name="jsWidth"
                  formControlName="w"
                  required
                  class="form-control"
                />
              </div>
              <div class="col-6">
                <label>Height *</label>
                <input
                  id="jsHeightDSP"
                  nz-input
                  type="number"
                  name="jsHeight"
                  formControlName="h"
                  required
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="part right">
        <div class="row b-row dsp-api-link-wrap">
          <div class="col-12">
            <div class="form-title">
              Endpoint & API Stats
              <app-tooltip
                [tooltipTitle]="
                  'Links for receiving statistics from the endpoint and provide statistic from the platform to the endpoint'
                "
              ></app-tooltip>
            </div>
          </div>
          <div *ngIf="createDspService.isPreBidConnection()" class="col-12">
            <div class="form-group">
              <label>Prebid Server *</label>
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select PreBid Server"
                formControlName="selectedPreBidServer"
                (ngModelChange)="onChangePreBidServer($event)"
                name="selectedPreBidServer"
                required
              >
                <nz-option
                  *ngFor="let server of createDspService.serversPreBid"
                  [nzValue]="server.id"
                  [nzLabel]="server.name"
                  [nzDisabled]="
                    createDspService.getIsDisabledPreBidOption(server.name)
                  "
                  nzCustomContent
                >
                  <span
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="
                      createDspService.getTooltipForPreBidServer(server.name)
                    "
                    nzTooltipPlacement="top"
                    >{{ server.name }}
                  </span>
                </nz-option>
              </nz-select>
            </div>
            <div class="block-fields" *ngIf="createDspService.isShowFields">
              <h3 class="prebid-header">Additional Prebid Fields</h3>
              <div
                class="form-group"
                *ngFor="
                  let item of createDspService.serverPreBid;
                  let i = index
                "
              >
                <span *ngIf="item.type !== 'boolean'">
                  <label
                    >{{ item.name }}
                    <span
                      *ngIf="createDspService.isRequiredPreBidField(item.name)"
                    >
                      *
                    </span>
                    <app-tooltip
                      *ngIf="item.tooltip"
                      [tooltipTitle]="item.tooltip"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    [name]="getDynamicNameForField(item.name)"
                    (input)="onChangeInput($event)"
                    [(ngModel)]="item.field"
                    [ngModelOptions]="{ standalone: true }"
                    [required]="
                      createDspService.isRequiredPreBidField(item.name)
                    "
                  />
                </span>
                <div *ngIf="item.type === 'boolean'" class="check-tooltip">
                  <label
                    nz-checkbox
                    [(ngModel)]="item.field"
                    [ngModelOptions]="{ standalone: true }"
                  >
                    {{ item.name }}
                  </label>
                  <app-tooltip
                    *ngIf="item.tooltip"
                    [tooltipTitle]="item.tooltip"
                  ></app-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="createDspService.isRtbConnection()" class="col-12">
            <div class="form-group">
              <label>
                Custom Adapter
                <app-tooltip [tooltipTitle]="'API adapters list'"></app-tooltip>
              </label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Custom Adapter"
                formControlName="selectedAdapters"
                name="selectedAdapters"
                (ngModelChange)="onChangeCustomAdapters($event)"
              >
                <nz-option
                  *ngFor="let adapter of createDspService.rtbAdapters"
                  [nzValue]="adapter.id"
                  [nzLabel]="adapter.name"
                  [nzDisabled]="isDisabledOption(adapter.name)"
                  nzCustomContent
                >
                  <span
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="
                      createDspService.getTooltipForAdapter(adapter.name)
                    "
                    nzTooltipPlacement="top"
                    >{{ adapter.name }}
                  </span>
                </nz-option>
              </nz-select>
            </div>
            <div class="block-fields" *ngIf="createDspService.isShowFields">
              <h3 class="prebid-header">Additional Adapters Fields</h3>
              <div
                class="form-group"
                *ngFor="let item of createDspService.adaptersRtb; let i = index"
              >
                <label class="label-title"
                  >{{ item.name }}
                  <span *ngIf="isRequiredAdapterField(item.name)"> * </span>
                  <app-tooltip
                    *ngIf="item.tooltip"
                    [tooltipTitle]="item.tooltip"
                  ></app-tooltip>
                </label>
                <ng-container
                  [ngSwitch]="item.parentName === 'Custom Extensions'"
                >
                  <textarea
                    *ngSwitchCase="true"
                    nz-input
                    class="form-control"
                    (input)="
                      onChangeRtbAdapterField($event, item.field, item.name)
                    "
                    [(ngModel)]="item.field"
                    [ngModelOptions]="{ standalone: true }"
                    [required]="isRequiredAdapterField(item.name)"
                  ></textarea>
                  <input
                    *ngSwitchCase="false"
                    nz-input
                    class="form-control"
                    (input)="
                      onChangeRtbAdapterField($event, item.field, item.name)
                    "
                    [(ngModel)]="item.field"
                    [ngModelOptions]="{ standalone: true }"
                    [required]="isRequiredAdapterField(item.name)"
                    [disabled]="item.disabled"
                  />
                </ng-container>
              </div>
            </div>

            <div *ngIf="createDspService.isFreewheelAdapter">
              <div class="switch-wrap__row freewheel-keywords-wrap">
                <div
                  class="switch-wrap__column column-switch"
                  style="justify-content: space-between"
                >
                  <div class="column-switch__label">
                    <span>FreeWheel Keywords</span>
                    <div class="icon">
                      <app-tooltip
                        tooltipTitle="When enabled, additional keyword-specific input fields become available. Values entered in these fields can be injected into the request as a fallback if the corresponding values are not present in the incoming request.
                        The system always parses keyword values from the request first, regardless of this setting, and uses the UI input only if no matching value is found."
                      ></app-tooltip>
                    </div>
                  </div>
                  <div class="column-switch__switch">
                    <nz-switch
                      [(ngModel)]="createDspService.isFreewheelKeywordsEnabled"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="
                        createDspService.onFreewheelKeywordsToggleHandler(
                          $event
                        )
                      "
                    ></nz-switch>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="createDspService.isFreewheelKeywordsEnabled">
                <div class="form-group">
                  <label class="label-title">
                    Timezone
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_h_x_timezone field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: -05:00"
                    [(ngModel)]="
                      createDspService.freewheelKeywordsData.timezone
                    "
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    City
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_h_x_city field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: Phoenix"
                    [(ngModel)]="createDspService.freewheelKeywordsData.city"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    DMA
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_h_x_dma field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: 501"
                    [(ngModel)]="createDspService.freewheelKeywordsData.dma"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    State
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_h_x_state field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: Arizona"
                    [(ngModel)]="createDspService.freewheelKeywordsData.state"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    Programmer Brand
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_content_programmer_brand field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: Disney"
                    [(ngModel)]="
                      createDspService.freewheelKeywordsData.programmer_brand
                    "
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    Channel
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_content_programmer_brand_channel field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: ESPN"
                    [(ngModel)]="createDspService.freewheelKeywordsData.channel"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    Genre
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_content_genre field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: genre 1, genre 2"
                    [(ngModel)]="createDspService.freewheelKeywordsData.genre"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    Language
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_content_language field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: en, es"
                    [(ngModel)]="
                      createDspService.freewheelKeywordsData.language
                    "
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    Content Rating
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_content_rating field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: TV-PG"
                    [(ngModel)]="
                      createDspService.freewheelKeywordsData.content_rating
                    "
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    Content Stream Mode
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_content_stream_mode field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: live"
                    [(ngModel)]="
                      createDspService.freewheelKeywordsData.content_stream_mode
                    "
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    Custom Key-Value Pair
                    <app-tooltip
                      tooltipTitle="Allows adding custom fields to the keywords object. Enter the field name in the first field and its value in the second (multiple values can be separated by commas). For formatting details, please consult the FreeWheel team."
                    ></app-tooltip>
                  </label>
                  <div class="freewheel-kv-wrapper">
                    <ng-container
                      *ngFor="
                        let pair of createDspService.freewheelKeyValuePairs;
                        let i = index
                      "
                    >
                      <div class="freewheel-kv-block">
                        <div *ngIf="i > 0" class="freewheel-kv-optional-label">
                          <span class="freewheel-kv-optional-label__text"
                            >Optional keywords fields</span
                          >
                          <button
                            class="freewheel-kv-remove-btn"
                            (click)="
                              createDspService.removeFreewheelKeyValuePair(i)
                            "
                          >
                            Remove
                            <span
                              nz-icon
                              nzType="delete"
                              nzTheme="outline"
                            ></span>
                          </button>
                        </div>
                        <div class="freewheel-kv-inputs">
                          <input
                            nz-input
                            class="form-control"
                            placeholder="objectname"
                            [(ngModel)]="pair.key"
                            [ngModelOptions]="{ standalone: true }"
                            nz-tooltip
                            nzTooltipOverlayClassName="item-tooltip"
                            nzTooltipPlacement="top"
                            nzTooltipTitle="Enter the object name as a single value. If the name consists of multiple words, join them with underscores (e.g. my_object_name)"
                          />
                          <input
                            nz-input
                            class="form-control"
                            placeholder="example: value_1, value_2, value_3"
                            [(ngModel)]="pair.value"
                            [ngModelOptions]="{ standalone: true }"
                            nz-tooltip
                            nzTooltipOverlayClassName="item-tooltip"
                            nzTooltipPlacement="top"
                            nzTooltipTitle="Enter one or more values separated by commas (e.g. value_one, value_two, value_three)"
                          />
                        </div>
                      </div>
                    </ng-container>

                    <div
                      class="freewheel-kv-footer"
                      [class.end]="
                        createDspService.freewheelKeyValuePairs.length < 5
                      "
                    >
                      <span
                        *ngIf="createDspService.isFreewheelKvAtMax"
                        class="freewheel-kv-warning"
                      >
                        <span
                          nz-icon
                          nzType="info-circle"
                          nzTheme="outline"
                        ></span>
                        You can add only 5 addition fields
                      </span>
                      <button
                        nz-button
                        nzType="default"
                        class="freewheel-kv-add-btn"
                        [disabled]="createDspService.isFreewheelKvAtMax"
                        (click)="createDspService.addFreewheelKeyValuePair()"
                      >
                        <span nz-icon nzType="plus" nzTheme="outline"></span>
                        Add new field
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-12">
            <div
              class="endpoint-link"
              *ngIf="!createDspService.isPreBidConnection()"
            >
              <div class="row b-row dsp-api-link-wrap">
                <div class="col-12">
                  <div class="form-group mb-30">
                    <label
                      >{{
                        createDspService.connectionTypeEndpointLabel[
                          createDspService.connectionType
                        ]
                      }}
                      *</label
                    >
                    <textarea
                      nz-input
                      class="form-control"
                      formControlName="endpoint"
                      name="endpoint"
                      required
                    ></textarea>
                  </div>
                </div>
              </div>
              <div
                class="col-3 button-right"
                *ngIf="!createDspService.isJSConnection()"
              >
                <button
                  class="button"
                  nz-button
                  nzType="primary"
                  (click)="
                    onEndpointUrlTest(
                      createDspService.formValue.endpoint,
                      $event
                    )
                  "
                >
                  Test
                </button>
              </div>
            </div>
          </div>

          <div
            class="col-12"
            *ngIf="
              createDspService.isJSConnection() ||
              createDspService.isVastConnection()
            "
          >
            <div class="form-group">
              <button class="btn btn_macros" (click)="showMacrosList()">
                Macros List
              </button>
            </div>
            <hr />
          </div>

          <div class="col-12">
            <app-validate-endpoint-url
              [endpointUrl]="createDspService.endpointUrl"
              [endpointValidationStatuses]="
                createDspService.endpointValidationStatusItems
              "
              [region]="createDspService.region"
              [type]="'dsp'"
            ></app-validate-endpoint-url>
          </div>

          <div
            class="form-group"
            *ngIf="
              createDspService.isRtbConnection() ||
              createDspService.isPreBidConnection()
            "
          >
            <div class="col-12">
              <div class="form-group">
                <label class="label-title"
                  >Call DSP's NURL
                  <app-tooltip
                    [tooltipTitle]="'Call DSP\'s NURL'"
                  ></app-tooltip>
                </label>
                <nz-select
                  nzShowSearch
                  nzPlaceHolder="Select DSP's NURL"
                  name="nurl"
                  formControlName="nurl"
                >
                  <nz-option
                    *ngFor="let nurl of createDspService.nurlOptions"
                    [nzValue]="nurl.id"
                    [nzLabel]="nurl.name"
                  ></nz-option>
                </nz-select>
              </div>
            </div>
          </div>
          <div class="col-9">
            <div class="form-group">
              <label for="dspApiUrl">DSP's Statistic API link</label>
              <input
                nz-input
                type="default"
                class="form-control"
                placeholder="Place API link"
                name="dspApiUrl"
                id="dspApiUrl"
                formControlName="apiLink"
                (change)="
                  validateLink(createDspService.formValue['apiLink'], $event)
                "
              />
              <app-check-endpoint-status
                [endpointValidationStatuses]="
                  createDspService.apiLinkValidationStatus
                "
                [apilink]="createDspService.apiLink"
                [side]="'dsp'"
                (hasError)="getError($event)"
              ></app-check-endpoint-status>
              <label for=""
                ><small>replace date with a placeholder [%Y-m-d%]</small></label
              >
            </div>
          </div>
          <div class="col-3">
            <button
              buttonLabel="testApiLinkDSP"
              nz-button
              nzType="default"
              class="test-link-button"
              (click)="
                onApiLinkTest(createDspService.formValue['apiLink'], $event)
              "
              [disabled]="createDspService.isDisabledTest"
            >
              Test
            </button>
          </div>
        </div>
        <div class="clearfix"></div>
        <hr />
        <div class="schain-settings__row">
          <div class="schain-settings__title">Schain settings</div>
          <div class="form-subtitle">
            Select one Schain type to apply. Only a single option - SSP Schain,
            Platform Schain, or Source Schain can be active per endpoint.
          </div>
          <div
            class="schain-settings__column"
            qa="additionalSettings"
            customLabel="schainSettings"
          >
            <div class="check-tooltip">
              <label
                nz-checkbox
                checkboxLabel="sspSchain"
                formControlName="isSspSchain"
                name="isSspSchain"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createDspService.restrictionTooltipMessageForEnterprise(
                    'SSP Schain'
                  )
                "
              >
                SSP Schain
              </label>
              <app-tooltip
                tooltipTitle="Enabling this option ensures that only the original SSP request’s schain nodes are sent to the DSP.
                SSP requests with an empty schain object will be dropped"
              ></app-tooltip>
            </div>
            <div class="check-tooltip">
              <label
                nz-checkbox
                checkboxLabel="platformSchain"
                formControlName="sChain"
                name="sChain"
                >Platform Schain</label
              >
              <app-tooltip
                [tooltipTitle]="createDspService.sChainToolTipText"
              ></app-tooltip>
            </div>
            <div class="check-tooltip">
              <label
                nz-checkbox
                checkboxLabel="sourceSSPSchain"
                formControlName="is_ssp_schain_source"
                name="is_ssp_schain_source"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createDspService.restrictionTooltipMessageForEnterprise(
                    'SSP Source Schain'
                  )
                "
                nzTooltipPlacement="top"
                >SSP Source Schain</label
              >
              <app-tooltip
                [tooltipTitle]="createDspService.SSPSourceSchainToolTipText"
              ></app-tooltip>
            </div>
            <div class="check-tooltip">
              <label
                nz-checkbox
                checkboxLabel="sourceDSPSchain"
                formControlName="schain_source"
                name="schain_source"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createDspService.restrictionTooltipMessageForEnterprise(
                    'DSP Source Schain'
                  )
                "
                nzTooltipPlacement="top"
                >DSP Source Schain</label
              >
              <app-tooltip
                [tooltipTitle]="createDspService.DSPSourceSchainToolTipText"
              ></app-tooltip>
            </div>
            <div class="check-tooltip">
              <label
                nz-checkbox
                checkboxLabel="completeSchain"
                formControlName="is_schain_complete"
                name="is_schain_complete"
                >Complete Schain</label
              >
              <app-tooltip
                [tooltipTitle]="
                  'When the toggle is enabled, only requests with complete schain object will be passed to DSP'
                "
              ></app-tooltip>
            </div>
            <div
              class="check-tooltip"
              *ngIf="!createDspService.isPreBidConnection()"
            >
              <label
                nz-checkbox
                formControlName="is_dual_schain"
                name="is_dual_schain"
              >
                Process Dual Schain Objects
              </label>
              <app-tooltip [tooltipTitle]="dualSchainTooltip"></app-tooltip>
            </div>

            <div
              class="check-tooltip"
              *ngIf="createDspService.formValue.schain_source"
            >
              <label nz-checkbox formControlName="ipd_only" name="ipd_only">
                IPD Only
              </label>
              <app-tooltip
                tooltipTitle="When enabled, only the IPD will be added. ASI and SID values will be ignored, and Schain node will not be added."
              ></app-tooltip>
            </div>

            <div
              class="check-tooltip"
              *ngIf="createDspService.formValue.isSspSchain"
            >
              <label
                nz-checkbox
                formControlName="is_schain_complete"
                name="is_schain_complete"
              >
                Drop empty schain
              </label>
              <app-tooltip
                tooltipTitle="Drop the requests consisting the empty schain object"
              ></app-tooltip>
            </div>
            <div
              class="form-group"
              selectLabel="customSchain"
              *ngIf="createDspService.isShowCustomSchain"
            >
              <label>Custom schain</label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Custom Schain"
                formControlName="schainCompany"
                name="schainCompany"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createDspService.restrictionTooltipMessageForEnterprise(
                    'Custom schain'
                  )
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="let schainValue of createDspService.schainValues"
                  [nzValue]="schainValue.id"
                  [nzLabel]="schainValue.sellerName"
                >
                </nz-option>
              </nz-select>
            </div>
            <div
              class="form-group"
              *ngIf="createDspService.isShowSchainNodeOrder"
            >
              <label>
                Schain Node Order
                <app-tooltip
                  tooltipTitle="Define the sequence in which the Platform and Custom Schain nodes are added to the DSP bid request."
                ></app-tooltip>
              </label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Schain Node Order"
                formControlName="schain_node_order"
                name="schain_node_order"
              >
                <nz-option
                  *ngFor="let order of createDspService.schainNodeOrderItems"
                  [nzValue]="order.id"
                  [nzLabel]="order.name"
                  nzCustomContent
                >
                  <span
                    class="item-name-container"
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="
                      order.isPresentSellerId ? '' : getTooltipTitle(order)
                    "
                    nzTooltipPlacement="top"
                  >
                    <span class="item-name">{{ order.name }}</span>
                    <span *ngIf="!order.isPresentSellerId" class="item-bracket"
                      >(
                      <span class="item-bracket-text">{{
                        order.isPresentSellerId ? "" : "No SID is found"
                      }}</span>
                      )</span
                    >
                  </span>
                </nz-option>
              </nz-select>
            </div>
            <div
              class="form-group"
              selectLabel="schainModification"
              *ngIf="createDspService.isShowSourceFile"
            >
              <label> Source Schain File </label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Source Schain File"
                formControlName="dsp_schain_source_file_id"
                name="dsp_schain_source_file_id"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createDspService.restrictionTooltipMessage(
                    'Source Schain File'
                  )
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="
                    let sourceSchain of createDspService.sourceSchainItems
                  "
                  [nzValue]="sourceSchain.id"
                  [nzLabel]="sourceSchain.fileName"
                ></nz-option>
              </nz-select>
            </div>
            <div
              class="form-group"
              selectLabel="schainModification"
              *ngIf="isShowCustomSchainFilters"
            >
              <label>Schain modification</label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Schain Modification"
                formControlName="schain_filter_option"
                name="schain_filter_option"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createDspService.restrictionTooltipMessage(
                    'Schain modification'
                  )
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="
                    let schainValue of createDspService.schainNodesFilters
                  "
                  [nzValue]="schainValue.id"
                  [nzLabel]="schainValue.name"
                ></nz-option>
              </nz-select>
            </div>
            <div
              class="form-group"
              selectLabel="schainCompleteStatus"
              *ngIf="isShowCustomSchainFilters"
            >
              <label>Complete Schain Status</label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Schain Modification"
                formControlName="schain_complete_option"
                name="schain_complete_option"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createDspService.restrictionTooltipMessage(
                    'Complete Schain Status'
                  )
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="let schainValue of createDspService.schainStatusItems"
                  [nzValue]="schainValue.id"
                  [nzLabel]="schainValue.name"
                ></nz-option>
              </nz-select>
            </div>
            <div
              class="form-group"
              selectLabel="schainLimit"
              *ngIf="isShowCustomSchainFilters"
            >
              <label class="label-title" name="nodesLimitDropdown">
                Schain node limit filter
                <app-tooltip
                  tooltipTitle="Select the maximum number of SSP Schain nodes allowed in the bid request for this endpoint.
                  Choosing “1 node”, for example, instructs the system to drop any SSP bid request containing more than 1 Schain node.
                  Attekmi Schain node is automatically included and located after SSP Schain nodes"
                ></app-tooltip>
              </label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Schain Modification"
                formControlName="schain_limit"
                name="schain_limit"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createDspService.restrictionTooltipMessage(
                    'Schain node limit filter'
                  )
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="
                    let schainValue of createDspService.schaninNodeLimitItems
                  "
                  [nzValue]="schainValue.id"
                  [nzLabel]="schainValue.name"
                ></nz-option>
              </nz-select>
            </div>
          </div>
        </div>
        <div
          class="schain-authorization"
          *ngIf="createDspService.partnerSettings?.schain_authorization"
        >
          <hr />
          <div class="schain-authorization__row">
            <div class="schain-authorization__title">
              Authorized Schain Only
            </div>
            <div class="schain-authorization__column">
              <div class="form-group form-group--schain-authorization">
                <label
                  nz-checkbox
                  formControlName="is_authorized_schain"
                  name="is_authorized_schain"
                  >Authorized Schain Only</label
                >
              </div>
              <div class="form-text">
                <p>
                  Allows only requests with schain nodes matching records in the
                  authorized sellers CSV. Available when the Schain
                  Authorization toggle (in Sellers.json Settings) and the
                  Platform Schain (in DSP EP settings) are enabled.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="part">
        <div class="form-title">Filters & Scanners</div>
        <hr
          *ngIf="
            createDspService.partnerSettings.usePMPreBid &&
            (createDspService.isRtbConnection() ||
              createDspService.isPreBidConnection())
          "
        />
        <div class="row b-row dsp-api-link-wrap">
          <div class="col-12">
            <div class="form-group">
              <div class="row b-row">
                <div class="col-12">
                  <label class="label-title"
                    >Countries
                    <app-tooltip
                      [tooltipTitle]="
                        'Choose allowed/blocked countries for this endpoint'
                      "
                    ></app-tooltip>
                  </label>
                </div>
                <div class="col-4">
                  <nz-select
                    [class.allowed-filter]="
                      createDspService.formValue['countriesTrigger'] === 1
                    "
                    [class.blocked-filter]="
                      createDspService.formValue['countriesTrigger'] === 0
                    "
                    formControlName="countriesTrigger"
                    name="countriesTrigger"
                  >
                    <nz-option
                      *ngFor="
                        let trigger of createDspService.allowCountriesTrigger
                      "
                      [nzValue]="trigger.id"
                      [nzLabel]="trigger.name"
                    ></nz-option>
                  </nz-select>
                </div>
                <div class="col-8">
                  <nz-tree-select
                    name="countriesList"
                    nzPlaceHolder="Select Country(s)"
                    nzPlacement="bottomRight"
                    [nzDropdownStyle]="{ width: '400px' }"
                    [class.allowed-filter]="
                      createDspService.formValue['countriesTrigger'] === 1
                    "
                    [class.blocked-filter]="
                      createDspService.formValue['countriesTrigger'] === 0
                    "
                    formControlName="countriesList"
                    [nzMaxTagCount]="7"
                    [nzMaxTagPlaceholder]="omittedCountriesPlaceHolder"
                    [nzNodes]="createDspService.countriesItems"
                    [nzAllowClear]="false"
                    [nzShowSearch]="true"
                    [nzMultiple]="true"
                    nzVirtualHeight="250px"
                    nzCheckable
                    [nzTreeTemplate]="customCountriesTpl"
                    [nzHideUnMatched]="true"
                  ></nz-tree-select>
                  <ng-template #omittedCountriesPlaceHolder let-omittedValues
                    >and {{ omittedValues.length }} more...</ng-template
                  >
                  <ng-template #customCountriesTpl let-item>
                    {{ item.title }}
                  </ng-template>
                </div>
              </div>
            </div>

            <div
              class="form-group"
              *ngIf="createDspService.isShowStatesControl()"
            >
              <div class="row b-row">
                <div class="col-4">
                  <nz-select
                    [class.allowed-filter]="
                      createDspService.formValue['states_trigger'] === 1
                    "
                    [class.blocked-filter]="
                      createDspService.formValue['states_trigger'] === 0
                    "
                    formControlName="states_trigger"
                    name="states_trigger"
                  >
                    <nz-option
                      *ngFor="
                        let trigger of createDspService.allowCountriesTrigger
                      "
                      [nzValue]="trigger.id"
                      [nzLabel]="trigger.name"
                    ></nz-option>
                  </nz-select>
                </div>
                <div class="col-8">
                  <nz-select
                    nzShowSearch
                    [nzShowArrow]="true"
                    nzPlaceHolder="Select State(s)"
                    [class.allowed-filter]="
                      createDspService.formValue['states_trigger'] === 1
                    "
                    [class.blocked-filter]="
                      createDspService.formValue['states_trigger'] === 0
                    "
                    formControlName="statesList"
                    name="statesList"
                    nzMode="multiple"
                    [nzFilterOption]="createDspService.filterStatesList"
                  >
                    <nz-option
                      *ngFor="let list of createDspService.statesList"
                      [nzValue]="list.id"
                      [nzLabel]="list.name"
                    >
                    </nz-option>
                  </nz-select>
                </div>
              </div>

              <div
                class="row b-row"
                *ngIf="createDspService.isShowStatesControl()"
              >
                <div class="switch-wrap__row">
                  <div class="switch-wrap__column column-switch">
                    <div class="column-switch__label">
                      <span>Allow processing of undefined U.S. states</span>
                      <div class="icon">
                        <app-tooltip
                          tooltipTitle="If enabled, the system will allow traffic from U.S. requests where the state could not be identified. 
                          If left unchecked, requests with undefined states will be dropped"
                        ></app-tooltip>
                      </div>
                    </div>
                    <div class="column-switch__switch">
                      <nz-switch
                        formControlName="is_undefined_state_allowed"
                        name="is_undefined_state_allowed"
                      ></nz-switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row b-row">
                <div class="col-12">
                  <label class="label-title"
                    >SSPs
                    <app-tooltip
                      [tooltipTitle]="
                        'Choose allowed/blocked SSPs for this endpoint'
                      "
                    ></app-tooltip>
                  </label>
                </div>
                <div class="col-4">
                  <nz-select
                    [class.allowed-filter]="
                      createDspService.formValue['sspTrigger'] === 1
                    "
                    [class.blocked-filter]="
                      createDspService.formValue['sspTrigger'] === 0
                    "
                    name="sspTrigger"
                    formControlName="sspTrigger"
                  >
                    <nz-option
                      *ngFor="
                        let trigger of createDspService.allowCountriesTrigger
                      "
                      [nzValue]="trigger.id"
                      [nzLabel]="trigger.name"
                    ></nz-option>
                  </nz-select>
                </div>
                <div class="col-8">
                  <nz-tree-select
                    name="dspList"
                    nzPlaceHolder="Select SSP Endpoint(s)"
                    nzPlacement="bottomRight"
                    [nzDropdownStyle]="{ width: '300px' }"
                    [class.allowed-filter]="
                      createDspService.formValue['sspTrigger'] === 1
                    "
                    [class.blocked-filter]="
                      createDspService.formValue['sspTrigger'] === 0
                    "
                    formControlName="sspList"
                    [nzMaxTagCount]="3"
                    [nzMaxTagPlaceholder]="omittedPlaceHolder"
                    [nzNodes]="createDspService.companiesSSPDropdown"
                    [nzAllowClear]="false"
                    [nzShowSearch]="true"
                    [nzMultiple]="true"
                    nzVirtualHeight="250px"
                    nzCheckable
                    [nzTreeTemplate]="customTpl"
                    [nzHideUnMatched]="true"
                  ></nz-tree-select>
                  <ng-template #omittedPlaceHolder let-omittedValues
                    >and {{ omittedValues.length }} more...</ng-template
                  >
                  <ng-template #customTpl let-item>
                    {{ item.title | trunc: [20] }}
                  </ng-template>
                </div>
              </div>
            </div>

            <div class="form-group" *ngIf="createDspService.isShowVideoSizes">
              <div class="row b-row" formGroupName="presetPlayerSizes">
                <div class="col-12">
                  <label class="label-title"
                    >Video Width Presets
                    <app-tooltip
                      [tooltipTitle]="videoWidthPresetsTooltip"
                    ></app-tooltip>
                  </label>
                </div>
                <div class="col-4">
                  <nz-select
                    [class.allowed-filter]="
                      createDspService.presetPlayerSizesGroup.value.trigger ===
                      1
                    "
                    [class.blocked-filter]="
                      createDspService.presetPlayerSizesGroup.value.trigger ===
                      0
                    "
                    [class.disabled-filter]="
                      createDspService.presetVideoSizeControl.disabled
                    "
                    name="videoWidthPresetsTrigger"
                    formControlName="trigger"
                  >
                    <nz-option
                      *ngFor="let trigger of createDspService.allowTrigger"
                      [nzValue]="trigger.id"
                      [nzLabel]="trigger.name"
                    >
                    </nz-option>
                  </nz-select>
                </div>
                <div class="col-8">
                  <nz-select
                    nzShowSearch
                    [nzShowArrow]="true"
                    nzPlaceHolder="Select Video Width Preset(s)"
                    [class.allowed-filter]="
                      createDspService.presetPlayerSizesGroup.value.trigger ===
                      1
                    "
                    [class.blocked-filter]="
                      createDspService.presetPlayerSizesGroup.value.trigger ===
                      0
                    "
                    [class.disabled-filter]="
                      createDspService.presetVideoSizeControl.disabled
                    "
                    formControlName="size"
                    name="playerSizes"
                    nzMode="multiple"
                  >
                    <nz-option
                      *ngFor="let list of createDspService.playerSizes"
                      [nzValue]="list.id"
                      [nzLabel]="list.name"
                    >
                    </nz-option>
                  </nz-select>
                </div>
              </div>
            </div>

            <div class="form-group" *ngIf="createDspService.isShowVideoSizes">
              <div class="row b-row" formGroupName="playerSizes">
                <div class="col-12">
                  <label class="label-title"
                    >Video Sizes
                    <app-tooltip
                      [tooltipTitle]="videoSizesTooltip"
                    ></app-tooltip>
                  </label>
                </div>
                <div class="col-4">
                  <nz-select
                    [class.allowed-filter]="
                      createDspService.playerSizesGroup.value.trigger === 1
                    "
                    [class.blocked-filter]="
                      createDspService.playerSizesGroup.value.trigger === 0
                    "
                    [class.disabled-filter]="
                      createDspService.videoSizeControl.disabled
                    "
                    name="videoSizeTrigger"
                    formControlName="trigger"
                  >
                    <nz-option
                      *ngFor="let trigger of createDspService.allowTrigger"
                      [nzValue]="trigger.id"
                      [nzLabel]="trigger.name"
                    ></nz-option>
                  </nz-select>
                </div>
                <div class="col-8">
                  <nz-select
                    nzShowSearch
                    [nzShowArrow]="true"
                    nzPlaceHolder="Select Video Size(s)"
                    [class.allowed-filter]="
                      createDspService.playerSizesGroup.value.trigger === 1
                    "
                    [class.blocked-filter]="
                      createDspService.playerSizesGroup.value.trigger === 0
                    "
                    [class.disabled-filter]="
                      createDspService.videoSizeControl.disabled
                    "
                    formControlName="size"
                    name="videoSizeList"
                    nzMode="multiple"
                    [nzDropdownRender]="sizeTemplate"
                  >
                    <nz-option
                      *ngFor="let list of createDspService.videoSizesList"
                      [nzValue]="list.id"
                      [nzLabel]="list.name"
                    ></nz-option>
                  </nz-select>
                  <ng-template #sizeTemplate>
                    <nz-divider></nz-divider>
                    <div class="container">
                      <input
                        type="text"
                        nz-input
                        #inputElement
                        placeholder="Width x Height"
                        (keypress)="enterSize($event)"
                        style="border-radius: 8px; border-color: #00a79d"
                      />
                      <button
                        nz-button
                        nzType="primary"
                        class="add-item"
                        (click)="
                          onAddSizeItem(
                            inputElement,
                            createDspService.videoSizesList
                          )
                        "
                      >
                        Add
                      </button>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>

            <div class="form-group" *ngIf="createDspService.isShowBannerSizes">
              <div class="row b-row">
                <div class="col-12">
                  <label class="label-title"
                    >Banner Sizes
                    <app-tooltip
                      [tooltipTitle]="bannerSizesTooltip"
                    ></app-tooltip>
                  </label>
                </div>
                <div class="col-4">
                  <nz-select
                    [class.allowed-filter]="
                      createDspService.formValue['sizeTrigger'] === 1
                    "
                    [class.blocked-filter]="
                      createDspService.formValue['sizeTrigger'] === 0
                    "
                    name="sizeTrigger"
                    formControlName="sizeTrigger"
                  >
                    <nz-option
                      *ngFor="
                        let trigger of createDspService.allowCountriesTrigger
                      "
                      [nzValue]="trigger.id"
                      [nzLabel]="trigger.name"
                    ></nz-option>
                  </nz-select>
                </div>
                <div class="col-8">
                  <nz-select
                    nzShowSearch
                    [nzShowArrow]="true"
                    nzPlaceHolder="Select Banner Size(s)"
                    [class.allowed-filter]="
                      createDspService.formValue['sizeTrigger'] === 1
                    "
                    [class.blocked-filter]="
                      createDspService.formValue['sizeTrigger'] === 0
                    "
                    formControlName="sizesList"
                    name="sizeList"
                    nzMode="multiple"
                    [nzDropdownRender]="sizeTemplate"
                  >
                    <nz-option
                      *ngFor="let list of createDspService.sizesList"
                      [nzValue]="list.id"
                      [nzLabel]="list.name"
                    ></nz-option>
                  </nz-select>
                  <ng-template #sizeTemplate>
                    <nz-divider></nz-divider>
                    <div class="container">
                      <input
                        type="text"
                        nz-input
                        #inputElement
                        placeholder="Width x Height"
                        (keypress)="enterSize($event)"
                        style="border-radius: 8px; border-color: #00a79d"
                      />
                      <button
                        nz-button
                        nzType="primary"
                        class="add-item"
                        (click)="
                          onAddSizeItem(
                            inputElement,
                            createDspService.sizesList
                          )
                        "
                      >
                        Add
                      </button>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row b-row">
                <div class="col-12">
                  <label class="label-title"
                    >Connection Types
                    <app-tooltip
                      [tooltipTitle]="
                        'Choose allowed/blocked connection types for this endpoint'
                      "
                    ></app-tooltip>
                  </label>
                </div>
                <div class="col-4">
                  <nz-select
                    [class.allowed-filter]="
                      createDspService.formValue['connectionTypeTrigger'] === 1
                    "
                    [class.blocked-filter]="
                      createDspService.formValue['connectionTypeTrigger'] === 0
                    "
                    name="connectionTypeTrigger"
                    formControlName="connectionTypeTrigger"
                  >
                    <nz-option
                      *ngFor="
                        let trigger of createDspService.allowCountriesTrigger
                      "
                      [nzValue]="trigger.id"
                      [nzLabel]="trigger.name"
                    ></nz-option>
                  </nz-select>
                </div>
                <div class="col-8">
                  <nz-select
                    nzShowSearch
                    [nzShowArrow]="true"
                    nzPlaceHolder="Select Connection Type(s)"
                    [class.allowed-filter]="
                      createDspService.formValue['connectionTypeTrigger'] === 1
                    "
                    [class.blocked-filter]="
                      createDspService.formValue['connectionTypeTrigger'] === 0
                    "
                    formControlName="connectionTypesList"
                    name="connectionTypesList"
                    nzMode="multiple"
                  >
                    <nz-option
                      *ngFor="let list of createDspService.connectionTypes"
                      [nzValue]="list.id"
                      [nzLabel]="list.name"
                    >
                    </nz-option>
                  </nz-select>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row b-row">
                <div class="col-12">
                  <label class="label-title"
                    >Device OS
                    <app-tooltip
                      [tooltipTitle]="
                        'Choose allowed/blocked device OS for this endpoint'
                      "
                    ></app-tooltip>
                  </label>
                </div>
                <div class="col-4">
                  <nz-select
                    [class.allowed-filter]="
                      createDspService.formValue['osTrigger'] === 1
                    "
                    [class.blocked-filter]="
                      createDspService.formValue['osTrigger'] === 0
                    "
                    name="osTrigger"
                    formControlName="osTrigger"
                  >
                    <nz-option
                      *ngFor="
                        let trigger of createDspService.allowCountriesTrigger
                      "
                      [nzValue]="trigger.id"
                      [nzLabel]="trigger.name"
                    ></nz-option>
                  </nz-select>
                </div>
                <div class="col-8">
                  <nz-select
                    nzShowSearch
                    [nzShowArrow]="true"
                    nzPlaceHolder="Select Operation System(s)"
                    [class.allowed-filter]="
                      createDspService.formValue['osTrigger'] === 1
                    "
                    [class.blocked-filter]="
                      createDspService.formValue['osTrigger'] === 0
                    "
                    formControlName="osList"
                    name="osList"
                    nzMode="multiple"
                  >
                    <nz-option
                      *ngFor="let list of createDspService.osList"
                      [nzValue]="list.id"
                      [nzLabel]="list.name"
                    >
                    </nz-option>
                  </nz-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="
            createDspService.partnerSettings.usePMPreBid &&
            (createDspService.isRtbConnection() ||
              createDspService.isPreBidConnection())
          "
          class="form-title"
        >
          Scanners
        </div>
        <div
          *ngIf="
            createDspService.partnerSettings.usePMPreBid &&
            (createDspService.isRtbConnection() ||
              createDspService.isPreBidConnection())
          "
          class="form-group"
        >
          <label>Protected Media Suspisious IVT</label>
          <div class="perc-place">
            <nz-select
              nzShowSearch
              formControlName="pmPrebidSuspiciousIVT"
              name="pmPrebidSuspiciousIVT"
            >
              <nz-option
                *ngFor="let item of createDspService.pmPrebidSuspiciousIVTItems"
                [nzValue]="item.id"
                [nzLabel]="item.name"
              >
              </nz-option>
            </nz-select>
          </div>
        </div>
        <div
          *ngIf="
            createDspService.partnerSettings.usePMPreBid &&
            (createDspService.isRtbConnection() ||
              createDspService.isPreBidConnection())
          "
          class="form-group"
        >
          <label>Protected Media Fraud IVT</label>
          <div class="perc-place">
            <nz-select
              nzShowSearch
              formControlName="pmPrebidFraudIVT"
              name="pmPrebidFraudIVT"
            >
              <nz-option
                *ngFor="let item of createDspService.pmPrebidFraudIVTItems"
                [nzValue]="item.id"
                [nzLabel]="item.name"
              >
              </nz-option>
            </nz-select>
          </div>
        </div>
        <div class="form-title">Filters</div>
        <div class="form-group form-group_chb form-group_filcheck column-check">
          <div
            class="check-tooltip-scanners"
            *ngIf="!createDspService.isJSConnection()"
          >
            <div class="checkbox">
              <label
                checkboxLabel="mismatchedIpFilter"
                nz-checkbox
                formControlName="mismatchedIpFilter"
                name="mismatchedIpFilter"
                >Mismatched IP Filter</label
              >
            </div>
            <app-tooltip
              tooltipTitle="The system will filter out requests with IPs on which more than 10% of mismatches are observed for the past 3 days.
            By IP mismatches, we mean cases when the IP in the request and the IP on which impression happens are different"
            ></app-tooltip>
          </div>
          <div
            class="check-tooltip-scanners"
            *ngIf="!createDspService.isJSConnection()"
          >
            <div class="checkbox">
              <label
                checkboxLabel="mismatchedBundlesFilters"
                nz-checkbox
                formControlName="mismatchedBundlesFilters"
                name="mismatchedBundlesFilters"
                >Mismatched Bundle Filter</label
              >
            </div>
            <app-tooltip
              tooltipTitle="The system will filter out requests with bundles on which more than 10% of mismatches are observed for the past 3 days. 
              By bundle mismatches, we mean cases when the bundle in the request and the bundle on which impression happens are different"
            ></app-tooltip>
          </div>
          <div
            class="check-tooltip-scanners"
            *ngIf="!createDspService.isJSConnection()"
          >
            <div class="checkbox">
              <label
                checkboxLabel="iabOttCtv"
                nz-checkbox
                formControlName="iabOttCtv"
                name="iabOttCtv"
                >IAB OTT/CTV compliance</label
              >
            </div>
            <app-tooltip
              [tooltipTitle]="
                'Enabling the compliance with IAB OTT/CTV additional specification'
              "
            ></app-tooltip>
          </div>
          <div class="check-tooltip-scanners">
            <div class="checkbox">
              <label
                checkboxLabel="useTCF"
                nz-checkbox
                formControlName="useTCF"
                (ngModelChange)="onChangeCheckedTCF($event)"
                name="useTCF"
                >TCF</label
              >
            </div>
            <app-tooltip
              [tooltipTitle]="
                'Filter out requests without user consent or if the user consent isn\'t passed in compliance with the IAB TCF requirements'
              "
            ></app-tooltip>
          </div>
          <div
            class="check-tooltip-scanners"
            *ngIf="createDspService.formValue['useTCF']"
          >
            <div class="checkbox">
              <label
                checkboxLabel="isOnlyWithConsent"
                nz-checkbox
                formControlName="is_only_with_consent"
                name="is_only_with_consent"
              >
                Only with consent
              </label>
            </div>
            <app-tooltip
              [tooltipTitle]="
                'If enabled - only requests with gdpr=1 will be passed to this DSP endpoint'
              "
            ></app-tooltip>
          </div>

          <div class="check-tooltip-scanners">
            <div class="checkbox">
              <label
                checkboxLabel="ccpaCompliance"
                nz-checkbox
                formControlName="ccpa_check"
                name="ccpa_check"
                >CCPA compliance</label
              >
            </div>
            <app-tooltip
              [tooltipTitle]="
                'This checkbox activates CCPA protocol for the DSP endpoint. If the request came from California, but without user consent, all personal data in the request will be anonymized'
              "
            ></app-tooltip>
          </div>
          <div class="check-tooltip-scanners">
            <div class="checkbox">
              <label
                checkboxLabel="onlyWithIFA"
                nz-checkbox
                formControlName="deviceIdRequired"
                name="deviceIdRequired"
                >Only with IFA</label
              >
            </div>
            <app-tooltip
              [tooltipTitle]="
                'If the request does not consist IFA, it will be dropped. All the valid IFA will be passed automatically'
              "
            ></app-tooltip>
          </div>
          <div
            class="check-tooltip-scanners"
            *ngIf="createDspService.formValue['deviceIdRequired']"
          >
            <div class="checkbox">
              <label
                nz-checkbox
                formControlName="allow_synth_ifa"
                name="allow_synth_ifa"
                >Allow the synthetic IFA</label
              >
            </div>
            <app-tooltip
              [tooltipTitle]="
                'In case the request consists synthetic IFA, it will be passed'
              "
            ></app-tooltip>
          </div>
          <div class="check-tooltip-scanners">
            <div class="checkbox">
              <label
                checkboxLabel="placementRequired"
                nz-checkbox
                formControlName="withPlacementOnly"
                name="withPlacementOnly"
                >Placement required</label
              >
            </div>
            <app-tooltip
              [tooltipTitle]="
                'Attekmi will filter out the requests not including “placement“ or “plcmt“ parameter'
              "
            ></app-tooltip>
          </div>

          <div class="check-tooltip-scanners">
            <div class="checkbox">
              <label
                checkboxLabel="ipv4Required"
                nz-checkbox
                formControlName="ipv4_required"
                name="ipv4_required"
                >IPv4 required</label
              >
            </div>
            <app-tooltip
              [tooltipTitle]="'Attekmi will filter out requests without IPv4'"
            ></app-tooltip>
          </div>

          <div class="check-tooltip-scanners">
            <div class="checkbox">
              <label
                checkboxLabel="badvLimit"
                nz-checkbox
                formControlName="has_badv_limit"
                name="has_badv_limit"
                >BADV limit</label
              >
            </div>
            <app-tooltip
              tooltipTitle="If you want to limit the number of entries for badv sent to the DSPs, please enable the checkbox.
              It will mean that platform cuts some entries and send only 49 blocked categories and domains."
            ></app-tooltip>
          </div>

          <div class="check-tooltip-scanners">
            <div class="checkbox">
              <label
                checkboxLabel="iabCategoriesLimit"
                nz-checkbox
                formControlName="has_iab_categories_limit"
                name="has_iab_categories_limit"
                >IAB sub-categories limit</label
              >
            </div>
            <app-tooltip
              tooltipTitle="If you want to limit the number of IAB categories sent to the DSPs, please enable the checkbox.
              It will mean that platform cuts all the IAB sub-categories from the request passed to the DSP."
            ></app-tooltip>
          </div>

          <div
            class="check-tooltip-scanners"
            *ngIf="
              createDspService.isRtbConnection() ||
              createDspService.isPreBidConnection()
            "
          >
            <div class="checkbox">
              <label
                checkboxLabel="onlyWithAppName"
                nz-checkbox
                formControlName="is_requests_empty_appname"
                name="is_requests_empty_appname"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createDspService.restrictionTooltipMessageForEnterprise(
                    'Only with app name'
                  )
                "
                nzTooltipPlacement="top"
              >
                Only with app name
              </label>
            </div>

            <app-tooltip
              [tooltipTitle]="
                'Enable this option to ensure only requests with app names are sent to DSPs'
              "
            ></app-tooltip>
          </div>

          <div
            class="check-tooltip-scanners"
            *ngIf="
              createDspService.isRtbConnection() ||
              createDspService.isPreBidConnection()
            "
          >
            <div class="checkbox">
              <label
                checkboxLabel="excludeMraidResponse"
                nz-checkbox
                name="exclude_mraid_response"
                formControlName="exclude_mraid_response"
              >
                Exclude mraid.js responses
              </label>
            </div>
            <app-tooltip [tooltipTitle]="mraidTooltip"></app-tooltip>
          </div>

          <div
            class="check-tooltip-scanners"
            *ngIf="
              createDspService.isRtbConnection() ||
              createDspService.isPreBidConnection()
            "
          >
            <div class="checkbox">
              <label
                checkboxLabel="addMraidImpressionPixel"
                nz-checkbox
                formControlName="mraid_impression_pixel"
                name="mraid_impression_pixel"
              >
                Add mraid.js impression pixel
              </label>
            </div>
            <app-tooltip
              [tooltipTitle]="
                'To add mraid.js impression pixel to the ADM in the DSP response'
              "
            ></app-tooltip>
          </div>

          <div class="check-tooltip-scanners">
            <div class="checkbox">
              <label
                nz-checkbox
                formControlName="is_coppa_filtration"
                name="is_coppa_filtration"
              >
                COPPA Filtration
              </label>
            </div>
            <app-tooltip
              tooltipTitle="Filters requests by COPPA value. Only requests matching the selected COPPA option (0 or 1) will be sent to DSP, others will be dropped."
            ></app-tooltip>
          </div>

          <div
            class="input-group"
            *ngIf="createDspService.formValue['is_coppa_filtration']"
          >
            <nz-select
              nzShowSearch
              formControlName="coppa_filter"
              name="coppa_filter"
            >
              <nz-option
                *ngFor="let item of createDspService.coppaFilterItems"
                [nzValue]="item.id"
                [nzLabel]="item.name"
              ></nz-option>
            </nz-select>
          </div>

          <div class="check-tooltip-scanners">
            <div class="checkbox">
              <label
                nz-checkbox
                formControlName="is_lmt_and_dnt_filter"
                name="is_lmt_and_dnt_filter"
              >
                LMT & DNT Filter
              </label>
            </div>
            <app-tooltip [tooltipTitle]="lmtAndDntFilterTooltip"></app-tooltip>
          </div>

          <div
            class="input-group"
            *ngIf="createDspService.formValue['is_lmt_and_dnt_filter']"
          >
            <nz-select
              nzShowSearch
              formControlName="lmt_and_dnt_filter"
              name="lmt_and_dnt_filter"
            >
              <nz-option
                *ngFor="let item of createDspService.lmtAndDntFilterItems"
                [nzValue]="item.id"
                [nzLabel]="item.name"
              ></nz-option>
            </nz-select>
          </div>

          <div class="check-tooltip-scanners" *ngIf="isBotmanPostBidIsEnabled">
            <div class="checkbox">
              <label
                checkboxLabel="botmanPostBidDSP"
                nz-checkbox
                name="botman_enable_postbid"
                formControlName="botman_enable_postbid"
                >Botman (Post-bid)</label
              >
            </div>
          </div>

          <div
            class="check-tooltip-scanners"
            *ngIf="isHumanFraudsensorEnabled()"
          >
            <div class="checkbox">
              <label
                checkboxLabel="humanFraudsensorPostBidDSP"
                nz-checkbox
                formControlName="fraud_sensor_enable_postbid"
                name="fraud_sensor_enable_postbid"
                >Human FraudSensor (Post-bid)</label
              >
            </div>
          </div>

          <div class="check-tooltip-scanners" *ngIf="isFraudLogixEnabled()">
            <div class="checkbox">
              <label
                checkboxLabel="fraudLogixPostBidDSP"
                nz-checkbox
                formControlName="fraud_logix_enable_postbid"
                name="fraud_logix_enable_postbid"
              >
                Fraudlogix (Post-bid)
              </label>
            </div>
          </div>

          <div
            class="check-tooltip-scanners"
            *ngIf="createDspService.partnerSettings.usePixalate"
          >
            <div class="checkbox">
              <label
                checkboxLabel="pixalatePostBidDSP"
                nz-checkbox
                name="is_pixalate_postbid"
                formControlName="is_pixalate_postbid"
                >Pixalate (Post-bid)</label
              >
            </div>
          </div>

          <div
            customLabel="pixalatePrebidBlockDSP"
            class="pixalate-block"
            *ngIf="
              createDspService.partnerSettings.pixalate_pb_settings &&
              createDspService.partnerSettings.usePixalatePrebid &&
              !createDspService.isJSConnection()
            "
            formGroupName="pixalate_pb_settings"
          >
            <div
              *ngIf="createDspService.partnerSettings.pixalate_pb_settings.ip"
            >
              <div class="checkbox">
                <label
                  checkboxLabel="pixalatePrebidIpDSP"
                  nz-checkbox
                  formControlName="ip"
                  name="pixalate_pb_settings.ip"
                  >Pixalate Pre-bid IP filter</label
                >
              </div>
              <div
                class="input-group"
                *ngIf="createDspService.formValue.pixalate_pb_settings.ip"
              >
                <label>Pixalate IP IVT Percent</label>
                <input
                  nz-input
                  type="number"
                  width="10"
                  id="pixalateIpPercentDSP"
                  name="pixalate_pb_settings.ip_percent"
                  formControlName="ip_percent"
                  (keyup)="preventInput($event, 'ip_percent')"
                  (click)="preventInput($event, 'ip_percent')"
                  class="form-control"
                />
              </div>
            </div>
            <div
              *ngIf="createDspService.partnerSettings.pixalate_pb_settings.ifa"
            >
              <div class="checkbox">
                <label
                  checkboxLabel="pixalatePrebidIFADSP"
                  nz-checkbox
                  formControlName="ifa"
                  name="pixalate_pb_settings.ifa"
                  >Pixalate Pre-bid IFA filter</label
                >
              </div>
              <div
                class="input-group"
                *ngIf="createDspService.formValue.pixalate_pb_settings.ifa"
              >
                <label>Pixalate IFA IVT Percent</label>
                <input
                  nz-input
                  type="number"
                  width="10"
                  id="pixalateIFAIVTPercentDSP"
                  name="pixalate_pb_settings.ifa_percent"
                  formControlName="ifa_percent"
                  (keyup)="preventInput($event, 'ifa_percent')"
                  (click)="preventInput($event, 'ifa_percent')"
                  class="form-control"
                />
              </div>
            </div>
            <div
              *ngIf="createDspService.partnerSettings.pixalate_pb_settings.ua"
            >
              <div class="checkbox">
                <label
                  checkboxLabel="pixalatePrebidUADSP"
                  nz-checkbox
                  formControlName="ua"
                  name="pixalate_pb_settings.ua"
                  >Pixalate Pre-bid UA filter</label
                >
              </div>
            </div>
            <div
              *ngIf="createDspService.partnerSettings.pixalate_pb_settings.ott"
            >
              <div class="checkbox">
                <label
                  checkboxLabel="pixalatePrebidOTTDSP"
                  nz-checkbox
                  formControlName="ott"
                  name="pixalate_pb_settings.ott"
                  >Pixalate Pre-bid OTT filter</label
                >
              </div>
              <div
                class="input-group"
                *ngIf="createDspService.formValue.pixalate_pb_settings.ott"
              >
                <label>Pixalate OTT IVT Percent</label>
                <input
                  nz-input
                  type="number"
                  width="10"
                  id="pixalateOttPercentDSP"
                  name="pixalate_pb_settings.ott_percent"
                  formControlName="ott_percent"
                  (keyup)="preventInput($event, 'ott_percent')"
                  (click)="preventInput($event, 'ott_percent')"
                  class="form-control"
                />
              </div>
            </div>
            <div
              *ngIf="
                createDspService.partnerSettings.pixalate_pb_settings.def_app
              "
            >
              <div class="checkbox">
                <label
                  checkboxLabel="pixalatePrebidDefAppDSP"
                  nz-checkbox
                  formControlName="def_app"
                  name="pixalate_pb_settings.def_app"
                  >Pixalate Pre-bid Defased App filter</label
                >
              </div>
            </div>
            <div
              *ngIf="
                createDspService.partnerSettings.pixalate_pb_settings.domain
              "
            >
              <div class="checkbox">
                <label
                  checkboxLabel="pixalatePrebidDomainDSP"
                  nz-checkbox
                  formControlName="domain"
                  name="pixalate_pb_settings.domain"
                  >Pixalate Pre-bid Domain filter</label
                >
              </div>
            </div>
            <div
              *ngIf="
                createDspService.partnerSettings.pixalate_pb_settings.hr_app
              "
            >
              <div class="checkbox">
                <label
                  checkboxLabel="pixalatePrebidBundleDSP"
                  nz-checkbox
                  formControlName="hr_app"
                  name="pixalate_pb_settings.hr_app"
                  >Pixalate Pre-bid Bundle filter</label
                >
              </div>
              <div
                class="input-group"
                *ngIf="createDspService.formValue.pixalate_pb_settings.hr_app"
              >
                <label>Pixalate Bundle IVT Percent</label>
                <input
                  nz-input
                  type="number"
                  width="10"
                  id="pixalateBundleIVTPercentDSP"
                  name="pixalate_pb_settings.hr_app_percent"
                  formControlName="hr_app_percent"
                  (keyup)="preventInput($event, 'hr_app_percent')"
                  (click)="preventInput($event, 'hr_app_percent')"
                  class="form-control"
                />
              </div>
            </div>
            <div
              *ngIf="
                createDspService.partnerSettings.pixalate_pb_settings.dc_subnet
              "
            >
              <div class="checkbox">
                <label
                  checkboxLabel="pixalatePrebidDcSubnetDSP"
                  nz-checkbox
                  formControlName="dc_subnet"
                  name="pixalate_pb_settings.dc_subnet"
                  >Pixalate Pre-bid Data Center IP filter</label
                >
              </div>
            </div>
          </div>
          <div class="selects-block">
            <div class="selects-block__column">
              <div class="form-group">
                <label>Secure</label>
                <nz-select
                  nzShowSearch
                  formControlName="secureOnly"
                  name="secureOnly"
                >
                  <nz-option
                    *ngFor="let option of createDspService.secureOptions"
                    [nzValue]="option.id"
                    [nzLabel]="option.name"
                  >
                  </nz-option>
                </nz-select>
              </div>
            </div>

            <div class="selects-block__column">
              <div class="form-group">
                <label>
                  Adult Filter
                  <app-tooltip
                    [tooltipTitle]="adultFilterTooltip"
                  ></app-tooltip>
                </label>
                <nz-select
                  nzShowSearch
                  formControlName="filterPorn"
                  name="filterPorn"
                >
                  <nz-option
                    *ngFor="let option of createDspService.pornFilter"
                    [nzValue]="option.id"
                    [nzLabel]="option.name"
                  >
                  </nz-option>
                </nz-select>
              </div>
            </div>
          </div>
        </div>
        <div class="form-title">Additional Settings</div>
        <div class="form-group form-group_chb form-group_filcheck column-check">
          <div
            class="check-tooltip-scanners"
            *ngIf="createDspService.isShowVastAdditionalSettings()"
          >
            <div class="checkbox">
              <label
                nz-checkbox
                formControlName="is_store_url"
                name="is_store_url"
                >Add Store URL</label
              >
            </div>
            <app-tooltip [tooltipTitle]="tooltipTemplate"></app-tooltip>
          </div>

          <div
            class="check-tooltip-scanners"
            *ngIf="createDspService.isShowRtbAdditionalSettings()"
          >
            <div class="checkbox">
              <label
                checkboxLabel="omsdk"
                nz-checkbox
                formControlName="is_omsdk"
                name="is_omsdk"
                >Pass OMSDK</label
              >
            </div>
            <app-tooltip
              tooltipTitle="If you would like to pass OMSDK parameters to the DSP, please select this checkbox. 
              In case the checkbox is deactivated, OMSDK parameters will be removed from the bid request even if we receive them in the original request from SSP."
            ></app-tooltip>
          </div>

          <div
            class="check-tooltip-scanners"
            *ngIf="createDspService.isShowRtbAdditionalSettings()"
          >
            <div class="checkbox">
              <label
                nz-checkbox
                formControlName="is_display_manager"
                name="is_display_manager"
                >Pass Display Manager</label
              >
            </div>
            <app-tooltip
              tooltipTitle="Controls whether displaymanager fields are passed to the DSP.
        When enabled, displaymanager and displaymanagerver will be forwarded if received from the SSP.
        When disabled, these fields will be removed from the outgoing request if received from the SSP."
            ></app-tooltip>
          </div>

          <div class="check-tooltip-scanners">
            <div class="checkbox">
              <label nz-checkbox formControlName="is_pchain" name="is_pchain"
                >Pass Pchain</label
              >
            </div>
            <app-tooltip
              tooltipTitle="Controls whether the pchain field is passed to the DSP.
          When enabled, the platform will include the pchain field if the data was received from the SSP.
          When disabled, pchain field will be removed from the outgoing request. This option becomes available only when at least one Schain type is activated."
            ></app-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div *nzModalFooter>
      <button
        class="btn-submit"
        nz-button
        type="submit"
        nzType="primary"
        [disabled]="createDspService.isDisableSubmit"
        (click)="onFormSubmit()"
        qa="generateEndpoint"
      >
        Generate Endpoint
      </button>
      <button
        class="btn-cancel"
        nz-button
        nzType="default"
        (click)="onCancel()"
        type="button"
      >
        Cancel
      </button>
    </div>
  </form>
</div>

<ng-template #tooltipTemplate>
  <p class="tooltip-body">
    When enabled, the system will automatically populate the store URL if it's
    missing in the incoming SSP request. The bundle ID from the request will be
    used to generate the store URL as follows:
    <br /><span class="article-link">
      <strong>Android:</strong> {{ androidTooltipUrl }}
    </span>
    <br /><span class="article-link">
      <strong>iOS:</strong> {{ iosTooltipUrl }}
    </span>
  </p>
</ng-template>

<ng-template #videoWidthPresetsTooltip>
  <div class="tooltip-body">
    Allow or block <span>ranges</span> of video player dimensions using
    <span>presets</span>. <br />
    Choose from prebuilt rules (e.g.
    <span>Block sizes smaller than < 250 px</span>). <br />
    Note: Selecting any preset here
    <span>disables "Video Sizes"</span> dropdown.
  </div>
</ng-template>

<ng-template #bannerSizesTooltip>
  <div class="tooltip-body">
    Allow or block <span>specific banner sizes</span>. <br />
    Choose from presets or add a custom size in <span>WxH</span> format (e.g.,
    <span>300x250</span>, <span>150x150</span>). <br />
    This filter applies only when the <span>Banner</span> ad format is selected.
  </div>
</ng-template>

<ng-template #videoSizesTooltip>
  <div class="tooltip-body">
    Allow or block <span>specific</span> video player sizes (e.g.,
    <span>640x360</span>, <span>1920x1080</span>). <br />
    Pick from presets or add a custom size in <span>WxH</span> format. <br />
    Note: Selecting any size here
    <span>disables "Video Width Presets"</span> dropdown.
  </div>
</ng-template>

<ng-template #dualSchainTooltip>
  <div class="tooltip-body">
    <div>
      Enable this option to process both source.schain (OpenRTB 2.6) and
      source.ext.schain (OpenRTB 2.5) objects if both are present in incoming
      SSP requests.
    </div>
    <div>
      The platform will apply internal logic to determine whether to preserve,
      merge, or discard one of the objects before forwarding to the DSP.
    </div>
    <br />
    <br />
    For detailed logic and examples, please refer to our
    <span (click)="createDspService.openLink()" class="article-link"
      >Knowledgebase article</span
    >
  </div>
</ng-template>

<ng-template #adultFilterTooltip>
  <div class="tooltip-body">
    <p class="tooltip-body__title">
      Choose how adult-oriented inventory should be handled:
    </p>
    <ul class="tooltip-body__list">
      <li>
        <b>Allow All Traffic</b>
        - Allow both adult and non-adult traffic
      </li>
      <li>
        <b>Exclude Adult</b>
        – Filter out all adult-oriented sources.
      </li>
      <li>
        <b>Only Adult</b>
        – Allow only adult-oriented sources.
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #lmtAndDntFilterTooltip>
  <div class="tooltip-body">
    <p class="tooltip-body__title">
      When this filter is enabled, incoming requests with privacy flags (LMT or
      DNT) can be excluded based on your selection:
    </p>

    <ul class="tooltip-body__list">
      <li>
        <b>Exclude All</b>
        - Drops all requests where LMT=1 or DNT=1
      </li>
      <li>
        <b>Exclude LMT=1</b>
        – Drops only requests with LMT=1
      </li>
      <li>
        <b>Exclude DNT=1</b>
        – Drops only requests with DNT=1
      </li>
    </ul>
  </div>
</ng-template>
